import { Box, Text } from 'grommet';
import React from 'react';
import CustomInput from '../../elements/custom_input';
import ReactGoogleAutocomplete from 'react-google-autocomplete';
import translate from '../../../i18n/translate';

const AddressInfo = ({ placeField, devis, onDevisChange, title }) => {
    return (
        <Box align='center' justify='center' gap='small'>
            <Box width={'large'} gap='small'>
                <Text>{title}</Text>
                <Box direction="column" style={{ width: "100%" }} gap="small">
                    <Box style={{ marginTop: 5 }}>
                        <ReactGoogleAutocomplete
                            value={devis[placeField.address]}
                            style={{ background: '#EDEDED', padding: 11, borderRadius: 10, fontSize: 16, border: 'none', width: '100%', height: 44 }}
                            apiKey={"AIzaSyBa3n60yKzDhlgz67vh9YUTwHSlrRzaa4g"}
                            placeholder={translate('address')}
                            onPlaceSelected={(place) => {
                                let parts = place.address_components;
                                let address = parts.filter(s => s.types && (s.types.includes('street_number') || s.types.includes('route'))).map(s => s.long_name).join(' ');
                                let zip = parts.filter(s => s.types && s.types.includes('postal_code')).map(s => s.long_name).join('');
                                let city = parts.filter(s => s.types && s.types.includes('locality')).map(s => s.long_name).join('');
                                onDevisChange(placeField.address, address);
                                onDevisChange(placeField.zip, zip);
                                onDevisChange(placeField.city, city);
                            }}
                            options={{
                                types: ['address'],
                                componentRestrictions: { country: "fr" },
                            }}
                            onChange={(event) => onDevisChange(placeField.address, event.target.value)}
                        />
                    </Box>
                    <Box
                        gap="small"
                        direction="row"
                        justify="center"
                    >
                        <Box style={{ width: '50%' }}>
                            <CustomInput
                                placeholder={translate('zip')}
                                onChange={(event) => onDevisChange(placeField.zip, event.target.value)}
                                value={devis[placeField.zip]}
                            />
                        </Box>
                        <Box style={{ width: '50%' }}>
                            <CustomInput
                                placeholder={translate('city')}
                                onChange={(event) => onDevisChange(placeField.city, event.target.value)}
                                value={devis[placeField.city]}
                            />
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default AddressInfo;